/* =====================================================================
   ANIMALPEZ · v6 (Pipefy Agentic · sep 2026)
   1) Guía de tallas: abre/cierra el panel y ubica el link junto a "Talla"
   2) Otros diseños de la línea: muestra el nombre del diseño al pasar el mouse
   3) Visor de fotos estilo Arc'teryx en la ficha (tira horizontal a pantalla completa)
   5) Más diseños: al tocar uno cambia la ficha (fotos, video, precio, tallas) sin recargar la página
   6) Menú PC: desplegables anchos con fotos (abrir/cerrar con mouse y teclado)
   ===================================================================== */
(function () {
  'use strict';
  var html = document.documentElement;

  /* ---------- 1) Guía de tallas ---------- */
  function placeSizeGuide(root) {
    (root || document).querySelectorAll('[data-ap-gt-open]').forEach(function (btn) {
      if (btn.dataset.apPlaced) return;
      var scope = btn.closest('.t4s-product__info-container') || btn.closest('form') || document;
      var title = scope.querySelector(
        '.t4s-swatch__option.is-t4s-name__talla .t4s-swatch__title,' +
        '.t4s-swatch__option.is-t4s-name__tallas .t4s-swatch__title,' +
        '.t4s-swatch__option.is-t4s-name__size .t4s-swatch__title'
      );
      if (title) { title.appendChild(btn); btn.classList.add('is-inline'); }
      btn.dataset.apPlaced = '1';
    });
  }
  function closeGuide(m) {
    if (!m) return;
    m.hidden = true;
    html.classList.remove('ap-lock');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ap-gt-open]');
    if (open) {
      e.preventDefault();
      var m = document.getElementById(open.getAttribute('data-ap-gt-open'));
      if (m) {
        if (m.parentNode !== document.body) document.body.appendChild(m);
        m.hidden = false;
        html.classList.add('ap-lock');
        var x = m.querySelector('.ap-gt__x'); if (x) x.focus();
      }
      return;
    }
    if (e.target.closest('[data-ap-gt-close]')) closeGuide(e.target.closest('[data-ap-gt]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-ap-gt]:not([hidden])').forEach(closeGuide);
  });

  /* ---------- 2) Otros diseños de la línea ---------- */
  function initSiblings(root) {
    (root || document).querySelectorAll('[data-ap-her]').forEach(function (w) {
      if (w.dataset.apInit) return; w.dataset.apInit = '1';
      var nm = w.querySelector('[data-ap-her-name]'); if (!nm) return;
      var def = nm.getAttribute('data-default') || nm.textContent;
      w.querySelectorAll('.ap-her__it').forEach(function (a) {
        a.addEventListener('mouseenter', function () { nm.textContent = a.getAttribute('data-name') || def; });
        a.addEventListener('mouseleave', function () { nm.textContent = def; });
        a.addEventListener('focus', function () { nm.textContent = a.getAttribute('data-name') || def; });
        a.addEventListener('blur', function () { nm.textContent = def; });
      });
    });
  }

  /* ---------- 3) Visor de fotos (ficha de producto) ---------- */
  var vs = null, strip = null, count = null, list = [];
  function sized(u, w) { if (!u) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function buildViewer() {
    vs = document.createElement('div');
    vs.className = 'ap-vs'; vs.hidden = true;
    vs.setAttribute('role', 'dialog'); vs.setAttribute('aria-modal', 'true'); vs.setAttribute('aria-label', 'Fotos del producto');
    vs.innerHTML =
      '<div class="ap-vs__strip" data-ap-vs-strip></div>' +
      '<button type="button" class="ap-vs__nav ap-vs__nav--prev" data-ap-vs-prev aria-label="Foto anterior"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="ap-vs__nav ap-vs__nav--next" data-ap-vs-next aria-label="Foto siguiente"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<div class="ap-vs__bar"><span class="ap-vs__count" data-ap-vs-count></span>' +
      '<button type="button" class="ap-vs__close" data-ap-vs-close>Cerrar<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>';
    document.body.appendChild(vs);
    strip = vs.querySelector('[data-ap-vs-strip]');
    count = vs.querySelector('[data-ap-vs-count]');
    vs.querySelector('[data-ap-vs-close]').addEventListener('click', closeViewer);
    vs.querySelector('[data-ap-vs-prev]').addEventListener('click', function () { go(current() - 1); });
    vs.querySelector('[data-ap-vs-next]').addEventListener('click', function () { go(current() + 1); });
    strip.addEventListener('scroll', function () { updateCount(); }, { passive: true });
    strip.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { strip.scrollLeft += e.deltaY; e.preventDefault(); }
    }, { passive: false });
    document.addEventListener('keydown', function (e) {
      if (!vs || vs.hidden) return;
      if (e.key === 'Escape') closeViewer();
      if (e.key === 'ArrowRight') go(current() + 1);
      if (e.key === 'ArrowLeft') go(current() - 1);
    });
  }
  function current() {
    var c = strip.scrollLeft + strip.clientWidth / 2, best = 0, bd = Infinity;
    Array.prototype.forEach.call(strip.children, function (it, i) {
      var mid = it.offsetLeft + it.offsetWidth / 2, d = Math.abs(mid - c);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }
  function go(i) {
    var n = strip.children.length; if (!n) return;
    i = Math.max(0, Math.min(n - 1, i));
    var it = strip.children[i];
    strip.scrollTo({ left: it.offsetLeft - (strip.clientWidth - it.offsetWidth) / 2, behavior: 'smooth' });
  }
  function updateCount() { if (count) count.textContent = (current() + 1) + ' / ' + strip.children.length; }
  function openViewer(urls, start) {
    if (!vs) buildViewer();
    strip.innerHTML = urls.map(function (u, i) {
      return '<figure class="ap-vs__it"><img src="' + sized(u, 1800) + '" srcset="' + sized(u, 900) + ' 900w, ' + sized(u, 1400) + ' 1400w, ' + sized(u, 1800) + ' 1800w" sizes="(max-width: 767px) 100vw, 70vw" alt="" draggable="false"' + (Math.abs(i - start) > 1 ? ' loading="lazy"' : '') + '></figure>';
    }).join('');
    vs.hidden = false;
    html.classList.add('ap-lock');
    var jump = function () {
      var it = strip.children[start];
      if (it) strip.scrollLeft = it.offsetLeft - (strip.clientWidth - it.offsetWidth) / 2;
      updateCount();
    };
    requestAnimationFrame(jump);
    var first = strip.children[start] && strip.children[start].querySelector('img');
    if (first && !first.complete) first.addEventListener('load', jump, { once: true });
    vs.querySelector('[data-ap-vs-close]').focus();
  }
  function closeViewer() { if (!vs) return; vs.hidden = true; html.classList.remove('ap-lock'); strip.innerHTML = ''; }
  document.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-main-media] [data-main-slide][data-media-type="image"]');
    if (!slide) return;
    var sec = slide.closest('[id^="shopify-section-"]');
    if (!sec || !/__main$/.test(sec.id)) return;          /* solo la ficha de producto */
    if (e.target.closest('button, a, [data-replace-quickview]')) return;
    var group = slide.closest('[data-main-media]');
    var cur = group.hasAttribute('data-ap-cur') ? group.getAttribute('data-ap-cur') : null;
    var nodes = Array.prototype.filter.call(group.querySelectorAll('[data-main-slide][data-media-type="image"]'), function (n) {
      if (!n.classList.contains('is--media-hide')) return true;
      if (cur === null) return false;                        /* galería de 3 fotos + video: el visor muestra */
      var g = n.getAttribute('data-ap-grp') || '';           /* todas las fotos del color y las generales    */
      return g === '' || (cur !== '' && g === cur);
    });
    var urls = [], start = 0;
    nodes.forEach(function (n) {
      var img = n.querySelector('img[data-master]'); if (!img) return;
      var u = img.getAttribute('data-master');
      if (urls.indexOf(u) > -1) return;
      if (n === slide) start = urls.length;
      urls.push(u);
    });
    if (!urls.length) return;
    e.preventDefault(); e.stopPropagation();
    openViewer(urls, start);
  }, true);

  /* ---------- 4) Tallas en Sale: punto rojo + nota debajo de las tallas ---------- */
  function markSaleSizes(root) {
    (root || document).querySelectorAll('[data-ap-sale-sizes]').forEach(function (note) {
      if (note.dataset.apInit) return; note.dataset.apInit = '1';
      var sizes = []; try { sizes = JSON.parse(note.getAttribute('data-ap-sale-sizes')) || []; } catch (e) {}
      var scope = note.closest('.t4s-product__info-container') || document;
      var opt = scope.querySelector('.t4s-swatch__option.is-t4s-name__talla, .t4s-swatch__option.is-t4s-name__tallas, .t4s-swatch__option.is-t4s-name__size');
      if (!opt) return;
      opt.querySelectorAll('[data-swatch-item]').forEach(function (it) {
        if (sizes.indexOf(it.getAttribute('data-value')) > -1) it.classList.add('is-ap-sale');
      });
      var list = opt.querySelector('.t4s-swatch__list');
      if (list) list.parentNode.insertBefore(note, list.nextSibling);
    });
  }

  /* ---------- 5) Más diseños: cambiar de producto sin recargar ---------- */
  var swapping = false;
  function swapIds(main) {
    var id = main.id.replace('shopify-section-', '');
    var ids = [id], pre = id.replace(/__main$/, '__');
    ['breadcrumb', 'tecnologias'].forEach(function (k) {
      if (document.getElementById('shopify-section-' + pre + k)) ids.push(pre + k);
    });
    return ids;
  }
  function reinitMain(sec) {
    /* Mismo arranque que usa Gecko al recargar la sección en el editor (des_adm) */
    var T = window.T4SThemeSP, $ = window.jQuery_T4NT;
    if (!T || !$ || typeof T.Product !== 'function') return false;
    var D = $(sec).find('[data-product-featured]:not(.initProducts__enabled)');
    if (!D.length) return false;
    D.addClass('initProducts__enabled');
    $('.t4s-sticky-atc').remove();
    $('.drift-bounding-box.drift-open').remove();
    var L = D.find('[data-main-media].flickityt4s');
    if (L.length > 0 && typeof T.Carousel === 'function') L[0].flickityt4s = new T.Carousel(L[0]);
    new T.Product(D);
    try { if (T.ProductZoom) T.ProductZoom(); } catch (err) {}
    try { if (T.PopupMFP) T.PopupMFP(); } catch (err) {}
    try { if (T.Tabs && T.Tabs.Default) T.Tabs.Default(); if (T.Tabs && T.Tabs.Accordion) T.Tabs.Accordion(); } catch (err) {}
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ap-her][data-swap] a[data-ap-swap]');
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var main = a.closest('[id^="shopify-section-"]');
    if (!main || !/__main$/.test(main.id) || !window.fetch || !window.DOMParser || !window.T4SThemeSP) return;
    e.preventDefault();
    if (a.classList.contains('is-on') || swapping) return;
    var url = a.getAttribute('href');
    var ids = swapIds(main);
    swapping = true;
    main.classList.add('ap-swapping');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data || !data[ids[0]]) throw new Error('sin sección');
        var row = main.querySelector('[data-ap-her]');
        var rowHTML = row && !row.hidden ? row.outerHTML : null;
        ids.forEach(function (id) {
          var el = document.getElementById('shopify-section-' + id);
          if (!el || !data[id]) return;
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          if (!fresh) return;
          if (id === ids[0] && rowHTML) {
            var nr = fresh.querySelector('[data-ap-her]');
            if (nr) nr.outerHTML = rowHTML;          /* la fila de diseños se queda igual */
          }
          el.className = fresh.className;
          el.innerHTML = fresh.innerHTML;
        });
        var nrow = main.querySelector('[data-ap-her]');
        if (nrow) {
          delete nrow.dataset.apInit;
          nrow.querySelectorAll('a[data-ap-swap]').forEach(function (x) {
            var on = x.getAttribute('href') === url;
            x.classList.toggle('is-on', on);
            if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
          });
          var nm = nrow.querySelector('[data-ap-her-name]');
          if (nm) { nm.setAttribute('data-default', a.getAttribute('data-name') || ''); nm.textContent = a.getAttribute('data-name') || ''; }
        }
        document.querySelectorAll('body > [data-ap-gt]').forEach(function (m) { m.parentNode.removeChild(m); });
        if (!reinitMain(main)) throw new Error('init');
        boot(main);
        try { history.replaceState(history.state, '', url); } catch (err) {}
        var name = a.getAttribute('data-name'), sep = document.title.lastIndexOf(' – ');
        if (name) document.title = name + (sep > -1 ? document.title.slice(sep) : '');
        main.classList.remove('ap-swapping');
        main.classList.add('ap-swapped');
        setTimeout(function () { main.classList.remove('ap-swapped'); }, 800);
        var media = main.querySelector('[data-main-media]');
        if (media && media.getBoundingClientRect().top < 0) {
          window.scrollTo({ top: Math.max(0, window.pageYOffset + main.getBoundingClientRect().top - 90), behavior: 'smooth' });
        }
        swapping = false;
      })
      .catch(function () { window.location.href = url; });
  });

  /* ---------- 5b) Más diseños: el botón «+N» muestra los que sobran ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ap-her-more]');
    if (!b) return;
    var box = b.closest('[data-ap-her]');
    if (!box) return;
    box.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    var first = box.querySelector('.ap-her__it.is-extra');   /* el botón se oculta: el foco pasa al primer diseño nuevo */
    if (first) first.focus();
  });

  /* ---------- 6) Menú PC: desplegables anchos con fotos ---------- */
  function initMega(root) {
    (root || document).querySelectorAll('.ap-mm').forEach(function (li) {
      if (li.dataset.apInit || !li.querySelector('.ap-mm__panel')) return;
      li.dataset.apInit = '1';
      var a = li.firstElementChild, t = null;
      function setOpen(on) {
        li.classList.toggle('is-open', on);
        if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      function open() {
        clearTimeout(t);
        document.querySelectorAll('.ap-mm.is-open').forEach(function (x) {
          if (x !== li) { x.classList.remove('is-open'); if (x.firstElementChild) x.firstElementChild.setAttribute('aria-expanded', 'false'); }
        });
        setOpen(true);
      }
      function close(now) { clearTimeout(t); t = setTimeout(function () { setOpen(false); }, now ? 0 : 160); }
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', function () { close(false); });
      li.addEventListener('focusin', open);
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(true); });
      li.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(true); if (a) a.focus(); } });
    });
  }


  /* ---------- 7) Tarjetas: compra rápida (elige la talla sin salir, igual al HTML) ---------- */
  function qbClose(p) {
    if (!p || p.hidden) return;
    p.hidden = true;
    var card = p.closest('.t4s-product');
    var b = card && card.querySelector('[data-ap-qb-open]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  function qbReset(p) {
    p.querySelectorAll('.ap-qb__sz.is-on').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
    var add = p.querySelector('[data-ap-qb-add]');
    if (!add) return;
    if (!add.dataset.label0) add.dataset.label0 = add.textContent;
    add.classList.remove('is-ready');
    add.removeAttribute('data-action-atc');
    add.removeAttribute('data-variant-id');
    add.setAttribute('href', add.dataset.base);
    add.textContent = add.dataset.label0;
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var openBtn = t.closest('[data-ap-qb-open]');
    if (openBtn) {
      e.preventDefault();
      var card = openBtn.closest('.t4s-product');
      var p = card && card.querySelector('[data-ap-qb]');
      if (!p) return;
      var willOpen = p.hidden;
      document.querySelectorAll('[data-ap-qb]').forEach(qbClose);
      if (willOpen) {
        qbReset(p);
        p.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    var panel = t.closest('[data-ap-qb]');
    if (!panel) { document.querySelectorAll('[data-ap-qb]').forEach(qbClose); return; }
    if (t.closest('[data-ap-qb-close]')) { e.preventDefault(); qbClose(panel); return; }
    var sz = t.closest('.ap-qb__sz');
    if (sz) {
      e.preventDefault();
      if (sz.disabled) return;
      panel.querySelectorAll('.ap-qb__sz.is-on').forEach(function (y) { y.classList.remove('is-on'); y.setAttribute('aria-pressed', 'false'); });
      sz.classList.add('is-on');
      sz.setAttribute('aria-pressed', 'true');
      var add = panel.querySelector('[data-ap-qb-add]');
      if (!add) return;
      if (!add.dataset.label0) add.dataset.label0 = add.textContent;
      var vid = sz.getAttribute('data-ap-qb-v');
      var base = add.dataset.base || add.getAttribute('href');
      add.classList.add('is-ready');
      add.setAttribute('data-action-atc', '');
      add.setAttribute('data-variant-id', vid);
      add.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid);
      add.textContent = add.dataset.txt || 'Agregar al carrito';
      return;
    }
    var addBtn = t.closest('[data-ap-qb-add]');
    if (addBtn) {
      if (!addBtn.hasAttribute('data-action-atc')) {
        e.preventDefault();
        panel.classList.remove('is-shake'); void panel.offsetWidth; panel.classList.add('is-shake');
        return;
      }
      /* El carrito AJAX de Gecko ([data-action-atc]) agrega y abre el carrito; aquí solo cerramos el panel. */
      setTimeout(function () { qbClose(panel); }, 900);
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-ap-qb]').forEach(qbClose);
  });

  /* ---------- 8) «Completa tu equipo»: mezcla al azar (29 sep) ----------
     La sección usa las recomendaciones de Shopify: hasta 10 productos relacionados con el que se está
     viendo (según lo que compra la gente en la tienda y el parecido entre productos; mejoran con el tiempo).
     Gecko las trae después de cargar la ficha; aquí se barajan y se dejan 8 en carrusel (1-oct, pedido del
     cliente): en PC se ven 4 con flechas ‹ ›, en celular se desliza con el dedo. Cada visita muestra otra mezcla. */
  function mixRecs(wrap) {
    var box = wrap && wrap.querySelector('.t4s_box_pr_grid');
    if (!box || box.hasAttribute('data-ap-mix')) return;
    box.setAttribute('data-ap-mix', '');
    var items = Array.prototype.filter.call(box.children, function (el) { return el.classList.contains('t4s-product'); });
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
    }
    var n = 8;
    items.forEach(function (el, k) { if (k < n) box.appendChild(el); else el.parentNode.removeChild(el); });
    recsNav(box);
  }
  function recsNav(box) {
    var host = box.parentNode;
    if (!host || host.querySelector('.ap-recs-nav')) return;
    host.classList.add('ap-recs-host');
    var mk = function (dir, label, d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ap-recs-nav ap-recs-nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>';
      b.addEventListener('click', function () {
        box.scrollBy({ left: (dir === 'prev' ? -1 : 1) * box.clientWidth, behavior: 'smooth' });
      });
      host.appendChild(b);
      return b;
    };
    var prev = mk('prev', 'Anteriores', 'M15 5l-7 7 7 7');
    var next = mk('next', 'Siguientes', 'M9 5l7 7-7 7');
    var upd = function () {
      var max = box.scrollWidth - box.clientWidth - 2;
      prev.disabled = box.scrollLeft <= 2;
      next.disabled = box.scrollLeft >= max;
      host.classList.toggle('ap-recs-host--static', max <= 0);
    };
    box.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function watchRecs(root) {
    var wrap = (root || document).querySelector('#pr_recommendations');
    if (!wrap || wrap.hasAttribute('data-ap-watch')) return;
    wrap.setAttribute('data-ap-watch', '');
    mixRecs(wrap);
    if (window.MutationObserver) new MutationObserver(function () { mixRecs(wrap); }).observe(wrap, { childList: true, subtree: true });
  }

  /* ---------- 9) Galería de la ficha: 3 fotos + video del color elegido (29 sep) ----------
     La ficha sale con 3 fotos y el video (4 fotos si no hay video), armado en Liquid (main-product).
     Al cambiar de color, Gecko avisa con «variant:changed» (en su jQuery) y aquí se muestran las fotos
     de ese color (data-ap-grp) + las generales, en ese orden, y se reacomoda la cuadrícula o el carrusel. */
  function galApply(gal, val) {
    var items = Array.prototype.slice.call(gal.querySelectorAll('[data-main-slide]'));
    if (!items.length) return;
    var type = function (it) { return it.getAttribute('data-media-type') || ''; };
    var isVid = function (it) { var t = type(it); return t === 'video' || t === 'external_video'; };
    var grp = function (it) { return it.getAttribute('data-ap-grp') || ''; };
    var ci = [], si = [], cv = null, sv = null;
    items.forEach(function (it) {
      var g = grp(it);
      if (type(it) === 'image') { if (val && g === val) ci.push(it); else if (g === '') si.push(it); }
      else if (isVid(it)) { if (val && g === val) { if (!cv) cv = it; } else if (g === '' && !sv) sv = it; }
    });
    var vid = cv || sv, max = vid ? 3 : 4;
    var list = ci.concat(si);
    if (!list.length) list = items.filter(function (it) { return type(it) === 'image'; });
    var show = list.slice(0, max);
    if (vid) show.push(vid);
    if (!show.length) return;
    var parent = items[0].parentNode;
    show.concat(items.filter(function (it) { return show.indexOf(it) < 0; })).forEach(function (it) {
      it.classList.toggle('is--media-hide', show.indexOf(it) < 0);
      it.classList.remove('is--media-last');
      it.setAttribute('data-index', show.indexOf(it) < 0 ? '' : String(show.indexOf(it)));
      parent.appendChild(it);
    });
    show[show.length - 1].classList.add('is--media-last');
    var n = show.length;
    gal.setAttribute('data-media-sizes', (n === 4 || n > 5) ? 'normal' : String(n));
    gal.setAttribute('data-ap-cur', val);
    var $ = window.jQuery_T4NT;
    if (!$) return;
    var $g = $(gal);
    try {
      if (gal.classList.contains('flickityt4s-enabled')) {
        $g.trigger('update.flickityt4s');
      } else if (gal.classList.contains('isotopet4s-enabled') && $g.isotopet4s) {
        /* Isotope esconde con display:none en línea; se limpia para que vuelva a mostrar las del color nuevo */
        items.forEach(function (it) { it.style.display = ''; });
        $g.isotopet4s('reloadItems');
        $g.isotopet4s();
      }
      if (window.lazySizesT4 && lazySizesT4.loader && lazySizesT4.loader.checkElems) lazySizesT4.loader.checkElems();
    } catch (err) {}
  }
  function galOnVariant(target, variant) {
    if (!target || !target.closest || !variant) return;
    var box = target.closest('[data-product-featured]') || target.closest('[id^="shopify-section-"]');
    var gal = box && box.querySelector('[data-main-media][data-ap-gal]');
    if (!gal) return;
    var opt = parseInt(gal.getAttribute('data-ap-gal'), 10) || 0;
    if (!opt || !variant.options) return;
    var val = String(variant.options[opt - 1] || '').toLowerCase().trim();
    if (val === (gal.getAttribute('data-ap-cur') || '')) return;
    galApply(gal, val);
  }
  var galBound = false;
  function galBind() {
    if (galBound || !window.jQuery_T4NT) return;
    galBound = true;
    window.jQuery_T4NT(document).on('variant:changed', function (e) { galOnVariant(e.target, e.currentVariant); });
  }
  galBind();
  document.addEventListener('DOMContentLoaded', galBind);
  window.addEventListener('load', galBind);

  /* ---------- Arranque ---------- */
  function boot(root) { placeSizeGuide(root); initSiblings(root); markSaleSizes(root); initMega(root); watchRecs(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
